/** Canonical URL prefix for the priorities.ai product design system hub and sub-pages. */
export const PRIORITIES_AI_DESIGN_PREFIX = '/priorities-ai-design-language';

export function isPrioritiesAiProductDesignPath(pathname: string): boolean {
  return (
    pathname === PRIORITIES_AI_DESIGN_PREFIX ||
    pathname.startsWith(`${PRIORITIES_AI_DESIGN_PREFIX}/`)
  );
}
